import NextSection from "@components/About/NextSection";
import cx from "classnames";
import styles from "./RestaurantInfo.module.scss";
import SteamCookingPot from "@components/Icons/SteamCookingPot";
import Icons from "@gstyles/styleguide/icons";
import { useTranslationContext } from "@providers/TranslationProvider";
import Link from "@components/Link";
import { usePageContext } from "@providers/PageProvider";
import { dinningPage } from "@utils/helper";
import _ from "lodash";

export default function RestaurantInfo() {
  const { i18n } = useTranslationContext();
  const { pageData } = usePageContext();
  const information: any = dinningPage.formatRestaurantInformation(pageData);
  const { cuisine, reservation, headChef, moreInfor, openingHours } =
    information;
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <NextSection className={cx(styles.nextSection)}>
        <div className={cx(styles.titleSection)}>
          {i18n.t("Dinning.restaurantInfo.title")}
        </div>
      </NextSection>
      <div className={cx(styles.content)}>
        <div className={cx(styles.infoItemWrapper)}>
          <div className={cx(styles.label)}>{_.get(cuisine, "title")}</div>
          <div className={cx(styles.infoWrapper)}>
            <div className="flex items-center">
              <SteamCookingPot />
              <div className={cx(styles.text, "ml-2")}>
                {_.get(cuisine, "value")}
              </div>
            </div>
            <Link href={_.get(cuisine, "button.href", "#")}>
              <div
                className={cx(
                  styles.text,
                  "underline decoration-solid cursor-pointer"
                )}
              >
                {_.get(cuisine, "button.label")}
              </div>
            </Link>
          </div>
        </div>
        <div className={cx(styles.infoItemWrapper)}>
          <div className={cx(styles.label)}>{_.get(reservation, "title")}</div>
          <div className={cx(styles.infoWrapper)}>
            <div className="flex items-center">
              <Icons
                name="phone-outline"
                color="#e8e7e6"
                className={cx(styles.icon)}
              />
              <div className={cx(styles.text)}>
                {_.get(reservation, "phone")}
              </div>
            </div>
            <div className="flex items-center">
              <Icons
                name="mail-outline"
                color="#e8e7e6"
                className={cx(styles.icon)}
              />
              <div className={cx(styles.text)}>
                {_.get(reservation, "email")}
              </div>
            </div>
            <div className="flex items-center">
              <Icons
                name="location-marker-outline"
                color="#e8e7e6"
                className={cx(styles.icon)}
              />
              <div className={cx(styles.text)}>
                {_.get(reservation, "address")}
              </div>
            </div>
          </div>
        </div>
        <div className={cx(styles.infoItemWrapper)}>
          <div className={cx(styles.label)}>
            {i18n.t("Dinning.restaurantInfo.openingHours.label")}
          </div>
          <div className={cx(styles.infoWrapper)}>
            <div className="flex items-center">
              <Icons
                name="clock-outline"
                color="#e8e7e6"
                className={cx(styles.icon)}
              />
              <div className={cx(styles.text)}>
                {`${_.get(openingHours, "openTime")} - ${_.get(
                  openingHours,
                  "closeTime"
                )}`}
              </div>
            </div>
            <div className="flex items-center">
              <Icons
                name="clock-outline"
                color="#e8e7e6"
                className={cx(styles.icon, "invisible")}
              />
              <div className={cx(styles.text)}>
                {_.get(openingHours, "note")}
              </div>
            </div>
          </div>
        </div>
        <div className={cx(styles.infoItemWrapper)}>
          <div className={cx(styles.label)}>{_.get(headChef, "title")}</div>
          <div className={cx(styles.infoWrapper)}>
            <div className={cx(styles.text)}>{_.get(headChef, "value")}</div>
          </div>
        </div>
        <div className={cx(styles.infoItemWrapper)}>
          <div className={cx(styles.label)}>{_.get(moreInfor, "title")}</div>
          <div className={cx(styles.infoWrapper)}>
            <Link
              href={_.get(moreInfor, "button.href", "#")}
              target="_blank"
              rel="noopener"
            >
              <div
                className={cx(
                  styles.text,
                  "underline decoration-solid cursor-pointer"
                )}
              >
                {_.get(moreInfor, "button.label", "")}
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
